import styled, { useTheme } from "styled-components";
import { Tag } from "components/ui/display/Tag";
import { TasksKanbanColumn } from "./TasksKanbanColumn";
import { TasksKanbanCard } from "./TasksKanbanCard";
import { useEffect, useRef, useState } from "react";
import { MaterialIcon } from "components/ui/shared/MaterialIcon";

export const TasksKanbanProjectWrapper = ({project, tasks}) => {
    
    const [isCollapsed, setIsCollapsed] = useState(false);

    const ref = useRef(null)

    useEffect(() => {
        const el = ref.current;
        if(!el) return;

        if(isCollapsed)
        {
            el.style.height = el.scrollHeight + 'px';
            // eslint-disable-next-line
            const x = el.offsetHeight;
            el.style.height = '0px';
            el.style.opacity = 0;
        }
        else
        {
            el.style.height = '0px';
            // eslint-disable-next-line
            const x = el.offsetHeight;
            el.style.height = el.scrollHeight + 'px';
            el.style.opacity = 1;
            const handleTransitionEnd = () => {
                el.style.height = 'auto';
                el.removeEventListener('transitionend', handleTransitionEnd);
            };

            el.addEventListener('transitionend', handleTransitionEnd);
        }
    }, [isCollapsed])
    
    const GlobalTheme = useTheme();

    return (
        <StyledTasksKanbanProjectWrapper className={isCollapsed ? 'projectWrapperCollapsed' : null}>
            <div className='projectWrapperHeader'>
                <MaterialIcon
                    name='arrow_drop_down'
                    weight={300}
                    onClick={() => setIsCollapsed(prev => !prev)}
                />
                <span>{project.projectName}</span>
                <Tag
                    text={tasks.length + (tasks.length !== 1 ? ' oppgaver' : ' oppgave')} 
                />
            </div>
            <div ref={ref} className="projectWrapperContent">
                <TasksKanbanColumn
                    id={'tasks-kanban-not-started-' + project.projectUuid}
                    title='Planlagt'
                    counter={tasks.filter(tsk => tsk && tsk.taskStatus === 'NotStarted').length}
                    color={GlobalTheme.colors.neutralSecondaryForeground}
                >
                    {
                        tasks.map(tsk => tsk && tsk.taskStatus === 'NotStarted' ? <TasksKanbanCard key={tsk.taskUuid} task={tsk}/> : null)
                    }
                </TasksKanbanColumn>

                <TasksKanbanColumn
                    id={'tasks-kanban-started-' + project.projectUuid}
                    title='Igangsatt'
                    counter={tasks.filter(tsk => tsk && tsk.taskStatus === 'Started').length}
                    color={GlobalTheme.colors.accentForeground}
                >
                    {
                        tasks.map(tsk => tsk && tsk.taskStatus === 'Started' ? <TasksKanbanCard key={tsk.taskUuid} task={tsk}/> : null)
                    }
                </TasksKanbanColumn>

                <TasksKanbanColumn
                    id={'tasks-kanban-stopped-' + project.projectUuid}
                    title='Stanset'
                    counter={tasks.filter(tsk => tsk && tsk.taskStatus === 'Stopped').length}
                    color={GlobalTheme.colors.warningForeground}
                >
                    {
                        tasks.map(tsk => tsk && tsk.taskStatus === 'Stopped' ? <TasksKanbanCard key={tsk.taskUuid} task={tsk}/> : null)
                    }
                </TasksKanbanColumn>

                <TasksKanbanColumn
                    id={'tasks-kanban-finished-' + project.projectUuid}
                    title='Fullført'
                    counter={tasks.filter(tsk => tsk && tsk.taskStatus === 'Finished').length}
                    color={GlobalTheme.colors.successForeground}
                >
                    {
                        tasks.map(tsk => tsk && tsk.taskStatus === 'Finished' ? <TasksKanbanCard key={tsk.taskUuid} task={tsk}/> : null)
                    }
                </TasksKanbanColumn>
            </div>
        </StyledTasksKanbanProjectWrapper>
    )
}

const StyledTasksKanbanProjectWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({theme}) => theme.spacing.lg};

    div.projectWrapperHeader
    {
        display: flex;
        align-items: center;
        gap: ${({theme}) => theme.spacing.md};
        user-select: none;

        > span
        {
            user-select: none;
            font-size: ${({theme}) => theme.fontSize.lg};
            font-weight: 500;
        }

        .icon
        {
            cursor: pointer;
            transition-duration: 220ms;
        }
    }

    div.projectWrapperContent
    {
        transition-duration: 220ms;
        display: flex;
        align-items: flex-start;
        gap: ${({theme}) => theme.spacing.md};
        overflow: hidden;
    }

    &.projectWrapperCollapsed div.projectWrapperHeader svg
    {
        transform: rotate(-90deg);
    }
`